import React, { Component } from 'react';
import Device from '../../devices/device';
import { Button, Checkbox } from '../../packages/components';
import Asset from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';
import RequestManager from '../../requests/RequestManager';
import TVEverywhereSaveTask from '../../requests/tasks/user/TVEverywhereSaveTask';
import store from '../../store';
import Utils from '../../utils/Utils';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import './styles.scss';
import GetUserInfoTask from '../../requests/tasks/user/GetUserInfoTask';
import logger from 'src/utils/logger/logger';

export default class LandingTVEverywhere extends Component {
    constructor(props) {
        super(props);
        this.ifPromptTVNode = props.ifPromptTVNode;
        this.history = props.history;
        this.state = {
            checked: false,
            page: 0,
            imageError: false

        }
        this.onClick = this.onClick.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        const { confirmation_page = false } = Utils.getApaMetadataKey("linkData_notification_config", `{"confirmation_page": false}`);
        this.showConfirmationPage = confirmation_page;

        this.title = Translator.get('landingIPTV_fullScreen_title_label', 'Ya puedes disfrutar de todos tus contenidos con tu app Claro TV en cualquier dispositivo');
        this.description = Translator.get('landingIPTV_fullScreen_description_label', 'Completa tus datos escaneando el código desde tu dispositivo móvil.')
        this.additionalDescription = Translator.get('landingIPTV_fullScreen_additionalDescription_label', 'También puedes seguir mirando la tv únicamente en este dispositivo')
        this.checkboxLabel = Translator.get('landingIPTV_fullScreen_checkDescription_label', 'No volver a mostrar este mensaje');
        this.optionButton = Translator.get('landingIPTV_fullScreen_option_button', 'VER CLARO TV');
        this.confirmTitle = Translator.get('landingIPTV_confirmScreen_title_label', '¿Estás seguro?');
        this.confirmDescription = Translator.get('landingIPTV_confirmScreen_description_label', 'Al completar tus datos podrías ingresar a Claro TV desde cualquier dispositivo.');
        this.confirmOption1Button = Translator.get('landingIPTV_confirmScreen_option1_button', 'COMPLETAR DATOS');
        this.confirmOption2Button = Translator.get('landingIPTV_confirmScreen__option2_button', 'VER CLARO TV');
        const region = DeviceStorage.getItem("region");
        this.region = region;
        this.defaultBackgroundImage = Asset.get(`landingIPTV_fullScreen_background_image`, './images/img_devices.png');
        this.backgroundImage = Asset.get(`landingIPTV_fullScreen_background_image_${region}`, '') || this.defaultBackgroundImage;
    }

    async componentDidMount() {
        await this.getUserHash();
        window.SpatialNavigation.focus("#landing-tv-everywhere a.focusable.button");

        let image = new Image();
        image.onerror = () => {
            this.setState({imageError: true})
            image.onerror = () => {};
        }
        image.src = this.backgroundImage;
    }

    componentDidUpdate(_, prevState) {
        if(prevState.page !== this.state.page) {
            window.SpatialNavigation.focus("#landing-tv-everywhere a.focusable.button");
            if(this.state.page === 0) {
                this.createQR();
            }
        }
    }

    async getUserHash() {
        const userHash = DeviceStorage.getItem('user_hash');
        if (!userHash || userHash === undefined || userHash === 'undefined' || userHash === '') {
            const { user } = store.getState();
            const email = user.email;
            const getUserInfoTask = new GetUserInfoTask(email);
            try {
                await RequestManager.addRequest(getUserInfoTask)
                    .then(result => {
                        const newUserHash = result.response.user_hash;
                        DeviceStorage.setItem('user_hash', newUserHash);
                        this.createQR();
                    })
                    .catch(error => {
                        throw new Error(error);
                    });
            } catch (error) {
                logger.error("Error trying to get GetUserInfoTask", error);
            }
        }
    }

    createQR() {
        const {user = {}} = store.getState();
        const u = DeviceStorage.getItem('user_hash');
        const { serial_id } = Device.getDevice().getConfig();
        const queryParams= Utils.buildQueryParams({ u, s: serial_id });

        new QRCode(document.getElementById("qrcode"), {
            text: `https://www.clarovideo.com/${this.region}/completa?${queryParams}`,
            width: 113,
            height: 113,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.L
        });
    }

    onCheck(isChecked) {
        this.setState({checked: isChecked})
    }

    onClick() {
        if(this.showConfirmationPage) {
            this.setState({page: 1})
        } else {
            this.onConfirm()
        }
    }

    onConfirm() {
        if(this.state.checked) {
            const saveTask = new TVEverywhereSaveTask();
            RequestManager.addRequest(saveTask)
                .then(response => logger.debug("Successfull TVEverywhereSaveTask: " + response))
                .catch(err => logger.error("Error TVEverywhereSaveTask: " + err));

        }
        this.ifPromptTVNode(this.history.location)
    }

    render() {
        return (
            <div id="landing-tv-everywhere">
                { this.state.page === 0 &&
                    <div className="page-0" style={{backgroundImage: this.state.imageError ? `url(${this.defaultBackgroundImage})`: `url(${this.backgroundImage})`}}>
                        <h1 className="title">{this.title}</h1>
                        <div className="right-container">
                            <p className="text1">{this.description}</p>
                            <div className="qrcontainer">
                                <div id="qrcode" className="qrcode"></div>
                            </div>
                            <p className="text2">{this.additionalDescription}</p>
                            <Checkbox name="noShowAgain"
                                label={this.checkboxLabel}
                                onChange={this.onCheck}
                                checked={this.state.checked}
                                variant='default'
                            />
                            <Button
                                type="button"
                                variant="primary"
                                className={"focusable button button-to-tv"}
                                onClick={this.onClick}>
                                {this.optionButton}
                            </Button>
                        </div>
                    </div>
                }
                { this.state.page === 1 && this.showConfirmationPage &&
                    <div className="page-1">
                        <h1 className="title">{this.confirmTitle}</h1>
                        <p className="text">{this.confirmDescription}</p>
                        <div>
                            <Button
                                type="button"
                                variant="primary"
                                className={"focusable button button-back"}
                                onClick={() => {
                                    this.setState({page: 0})
                                }}>
                            {this.confirmOption1Button}
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="button"
                                variant="primary"
                                className={"focusable button button-confirm"}
                                onClick={this.onConfirm}>
                                {this.confirmOption2Button}
                            </Button>
                        </div>
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LandingTVEverywhere/index.jsx